import styled from 'styled-components';

const StyledParagraph = styled.p`
  margin: 24px;
`;

const Placeholder = () => {
  return <StyledParagraph>No data to display.</StyledParagraph>;
};

export default Placeholder;
